<template>
  <div class="bbe-placeholder">
    <img :src="noMessageSelected" class="bbe-placeholder__image">
    <h2 class="bbe-placeholder__title">
      Choose a message
    </h2>
    <span class="bbe-placeholder__description">
            Pick a person from left menu and start your conversation
          </span>
  </div>
</template>

<script>
import noMessageSelected from '@/assets/images/choose_messge.png'
import imageForTracker from '@/assets/images/email_tracker.png'

export default {
  name: 'PlaceholderRightPanel',
  data () {
    return {
      noMessageSelected: noMessageSelected,
      imageForTracker: imageForTracker
    }
  },
  computed: {
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    user-select: none;
    pointer-events: none;

    &__image {
      width: 295px;
      object-fit: contain;
    }

    &__title {
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      margin-bottom: 7px;
    }

    &__description {
      @include global-font-light;
      color: $color-dove-gray;
      max-width: 200px;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/PlaceholderRightPanel/PlaceholderRightPanel.vue